import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  BookOpen,
  TrendingUp,
  Cog,
  Users,
  Mountain,
  Leaf,
  Globe2,
  LineChart,
  Wallet,
  ScrollText,
  ShieldAlert,
  FolderArchive,
  ChevronRight,
} from "lucide-react";

const navItems = [
  { to: "/overview", label: "Executive Overview", icon: LayoutDashboard, testid: "nav-overview" },
  { to: "/memorandum", label: "Information Memorandum", icon: BookOpen, testid: "nav-memorandum" },
  { to: "/value-creation", label: "Value Creation", icon: TrendingUp, testid: "nav-value-creation" },
  { to: "/financial-intelligence", label: "Financial & Value Intel", icon: Wallet, testid: "nav-financial-intelligence" },
  { to: "/operations", label: "Operations & Capacity", icon: Cog, testid: "nav-operations" },
  { to: "/workforce", label: "Capacity & Workforce", icon: Users, testid: "nav-workforce" },
  { to: "/geological", label: "Geological Overview", icon: Mountain, testid: "nav-geological" },
  { to: "/geo-esg", label: "Geological & ESG Intelligence", icon: Leaf, testid: "nav-geo-esg" },
  { to: "/regional", label: "Regional Context", icon: Globe2, testid: "nav-regional" },
  { to: "/financial", label: "Financial Performance", icon: LineChart, testid: "nav-financial" },
  { to: "/legal", label: "Legal & Compliance", icon: ScrollText, testid: "nav-legal" },
  { to: "/risk", label: "Risk & Insights", icon: ShieldAlert, testid: "nav-risk" },
  { to: "/data-room", label: "Document Data Room", icon: FolderArchive, testid: "nav-data-room" },
];

export default function Sidebar() {
  return (
    <aside
      data-testid="app-sidebar"
      className="w-64 flex-shrink-0 border-r border-slate-200 bg-white h-screen sticky top-0 flex flex-col z-20"
    >
      <div className="px-5 pt-6 pb-5 border-b border-slate-100">
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-md bg-slate-900 flex items-center justify-center">
            <Mountain size={18} className="text-amber-400" />
          </div>
          <div>
            <div className="font-display text-sm font-semibold tracking-tight text-slate-900 leading-none">
              Mining Asset
            </div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-slate-500 mt-1">
              Intelligence Platform
            </div>
          </div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={({ isActive }) =>
                `group flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-all ${
                  isActive
                    ? "bg-slate-900 text-white shadow-sm"
                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={16} className={isActive ? "text-amber-400" : "text-slate-400 group-hover:text-slate-700"} />
                  <span className="flex-1">{item.label}</span>
                  {isActive && <ChevronRight size={14} className="text-amber-400" />}
                </>
              )}
            </NavLink>
          );
        })}
      </nav>

      <div className="border-t border-slate-100 p-4">
        <div className="bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
          <div className="text-[10px] uppercase tracking-wider text-amber-700 font-bold">Demo Mode</div>
          <div className="text-[11px] text-slate-600 mt-0.5">Open access · login disabled</div>
        </div>
      </div>
    </aside>
  );
}
